module.exports = __webpack_public_path__ + "226e2abe4c4b2708e36d3a6b23f16516.svg";